import React from 'react'
import { Highlight } from '@multiagentbook/ui'
import { useTranslation } from 'react-i18next'
import { formatBookRevision, getCurrentBookRevision } from './changelog-data'

export interface BookStatsInlineData {
  total_chapters: number
  total_code_blocks: number
  total_figures: number
}

interface BookStatsInlineProps {
  stats: BookStatsInlineData
  className?: string
}

export const BookStatsInline: React.FC<BookStatsInlineProps> = ({
  stats,
  className = '',
}) => {
  const { t, i18n } = useTranslation('home')

  // Spelled out rather than shown as the raw "2026.08" identifier: this sits in
  // front of readers deciding whether to buy, and the answer they want is "is
  // this current?", not a version string to parse.
  const revised = formatBookRevision(getCurrentBookRevision(), i18n.language)

  return (
    <span className={className}>
      {t('bookStatsInline.spanning')}{' '}
      <Highlight>{stats.total_chapters}</Highlight> {t('bookStatsInline.chapters')},{' '}
      <Highlight>{stats.total_code_blocks}+</Highlight> {t('bookStatsInline.codeSnippets')},{' '}
      {t('bookStatsInline.and')}{' '}
      <Highlight>{stats.total_figures}</Highlight> {t('bookStatsInline.diagrams')}.
      {revised && (
        <>
          {' '}
          {t('bookStatsInline.lastUpdated')} <Highlight>{revised}</Highlight>.
        </>
      )}
    </span>
  )
}

export default BookStatsInline
